import {
    FETCH_ALL_SURVEY_QUESTION,
    FETCH_ALL_SURVEY_QUESTION_SUCCESS,
    HIDE_SURVEY_QUESTION_LOADER,
    SHOW_SURVEY_QUESTION_LOADER,
    SHOW_SURVEY_QUESTION_MESSAGE,
} from 'constants/ActionTypes';


export const fetchSurveyQuestions = () => {
    return {
        type: FETCH_ALL_SURVEY_QUESTION
    };
};
export const fetchSurveyQuestionsSuccess = (data) => {
    return {
        type: FETCH_ALL_SURVEY_QUESTION_SUCCESS,
        payload: data
    };
};
export const showSurveyQuestionMessage = (message) => {
    return {
        type: SHOW_SURVEY_QUESTION_MESSAGE,
        payload: message
    };
};
export const showSurveyQuestionLoader = () => {
    return {
        type: SHOW_SURVEY_QUESTION_LOADER,
    };
};
export const hideSurveyQuestionLoader = () => {
    return {
        type: HIDE_SURVEY_QUESTION_LOADER,
    };
};



// WEBPACK FOOTER //
// ./actions/SurveyQuestion.js